import apiUrl from '../../../constants'
import axios from 'axios'
import iptrackerdetails from '../../../iptrackerdetails'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'mapsubdepartmentusers',
    components: {
        VueElementLoading,
        Multiselect
    },
    data: function() {
        return {
            isCheckAll: false,
            userid: '',
            hubs: null,
            listSubDepartmentData:[],
            show:'',
            iptrackData:'',
            assignedProjects:[],
            projectids:[],
            checkAddRemoveOp: false,
            value: [],
            HubOps:''
        }
    },
    created: function() {
    },
    async mounted() {
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.iptrackData = userdetail
        this.localuserid = userdetail.userid;
        this.localusermailid = userdetail.email;

        if(this.$route.params.id==undefined){
          this.$router.push('/user');
        }else{
          var userid = this.$route.params.id;
          this.getUserData(userid);
        }
    },
    methods: {
        getUserData(userid) {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            this.input = ({
                userid: userid
            })

            this.show = true;
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'userDetails',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then(async result => {
                  this.userid = result.data.userdetails.userid;
                  this.userDetails = result.data.userdetails;
                  let projectRoles = result.data.projectdetails;
                  await this.getSubDepartmentlist();
                  await this.getAllAssignedProjectNames(this.userid);
                  this.show = false
                }, error => {
                    console.error(error)
                })
        },
        getSubDepartmentlist() {
          this.show = true
          this.listSubDepartmentData = [];
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');
          let tempHubZoneArr=[];
          this.input={}
          axios({
                  method: 'POST',
                  'url': apiUrl.api_url + 'getAllSubDepartmentList',
                  'data': this.input,
                  headers: {
                      'Authorization': 'Bearer ' + myStr
                  }
              })
              .then(result => {
                console.log("subDepartmentList>>",JSON.stringify(result.data.rows));
                  this.listSubDepartmentData = result.data.rows;
                  this.show = false;
              }, error => {
                  console.error(error)
              })
        },
        getAllAssignedProjectNames(userid){
          this.show = true;
          var userToken = window.localStorage.getItem('userToken');
          var myStr = userToken.replace(/"/g, '');
          this.input = {
              "userid" : userid
          };
          axios({
                method: 'POST',
                'url': apiUrl.api_url + 'userAppAccessDetails',
                data: this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
              })
              .then(result => {
                  this.assignedProjects = result.data;
                  this.show = false;
              }, error => {
                  console.error(error);
              })
        },
        removeOtherStatus(status){
          if(this.addHub==true && status=='addHub'){
              this.removeHub=false
          }
          if(this.removeHub==true && status=='removeHub'){
              this.addHub=false
          }
        },
        checkAll(){
            this.projectids = [];
            if(this.isCheckAll){ // Check all
              for (var key in this.assignedProjects) {
                this.projectids.push(this.assignedProjects[key].projectid);
              }
            }
        },
        updateCheckall: function(){
          if(this.projectids.length == this.assignedProjects.length){
             this.isCheckAll = true;
          }else{
             this.isCheckAll = false;
          }
        },
        updateUserSubDepartmentMappingAccess(){
          let subdepartmentids = [];
          if(this.value && this.value.length>0){
            subdepartmentids = [...new Set(this.value.map(item => item['SubdepartmentID']))];
          }
          var userToken = window.localStorage.getItem('userToken')
          var myStr     = userToken.replace(/"/g, '');

          this.input = ({
              userid: this.userid,
              SubdepartmentID: subdepartmentids,
              projectIds:[11],
          });
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'updateUserAccessSubDepartment',
              'data': this.input,
              headers: {
                  'Authorization': 'Bearer ' + myStr
              }
          })
          .then((response) => {
              if (response.data.errorCode == 0) {
                  this.$alertify.success(response.data.msg);
                  this.resetForm();
              } else if (response.data.errorCode == -1) {
                  this.$alertify.error(response.data.msg)
              }
              iptrackerdetails.checkUserIP(this.iptrackData,'Update User Access SubDepartment Application',this.$route.path,this.input,response.data);
          })
          .catch((httpException) => {
              console.error('exception is:::::::::', httpException)
          });

        },
        onSubmit: function(event) {
          this.$validator.validateAll().then((result) => {
            if(result)
            {
              //event.target.reset();
              //console.log('form is valid');
              if(this.userid!=undefined && this.userid!="")
              {
                //console.log("Form ready to submit update user");
                this.updateUserSubDepartmentMappingAccess();
              }
            }
          }).catch((errors) => {
            console.log('errors exist', this.errors)
          });
        },
        resetForm() {
            this.value = '';
            this.HubOps = '';
            this.isCheckAll = false;
            this.projectids = '';
            this.$validator.reset();
            this.errors.clear();
        }
    }
}


Validator.extend('validateOpStatus', {
    getMessage: field => "Please select one from add or remove hub.",
    validate: value => {
      let addhubop = document.getElementById("addHub");
      let removehubop = document.getElementById("removeHub");
      if(addhubop.checked==false && removehubop.checked==false){
        return false;
      }else{
        return true;
      }
    }
});



// WEBPACK FOOTER //
// ./src/views/components/mappingusersubdepartment/mappingusersubdepartment.component.js